/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';

import TextInput from 'uikit/inputs/components/textInput';

import styles from '../styles/uikitManageManageSearch.module.scss';

const ManageSearch = ({
  className = '',
  inputId = 'search-input',
  isDisabled = false,
  onFocus = () => {},
  onChange = () => {},
  onClick = () => {},
  placeholder = i18n.t('search-placeholder', 'Search...'),
  value = '',
}) => (
  <div className={classnames(styles.element, className)}>
    <TextInput
      className={styles.searchInput}
      id={inputId}
      isDisabled={isDisabled}
      onFocus={onFocus}
      onChange={onChange}
      onClick={onClick}
      placeholder={placeholder}
      shouldShowCloseButton={!!value}
      size="small"
      type="search"
      value={value}
    />
  </div>
);

ManageSearch.propTypes = {
  className: PropTypes.string,
  inputId: PropTypes.string,
  isDisabled: PropTypes.bool,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

export default ManageSearch;
